import { render, staticRenderFns } from "./ScanStatusTag.vue?vue&type=template&id=07030594"
import script from "./ScanStatusTag.vue?vue&type=script&lang=js"
export * from "./ScanStatusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports